// extracted by mini-css-extract-plugin
module.exports = {"newsletterContent":"Editor_newsletterContent__82rxj","touchpointcard":"Editor_touchpointcard__rPijC","disabledEditor":"Editor_disabledEditor__1UzeU"};